import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Storage from 'utils/Storage';
import { updateUserToken } from 'store/User';
import useSessionBootstrap from 'hooks/useSessionBootstrap';

function SsoContinue() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { bootstrap, accountModal } = useSessionBootstrap();

  useEffect( () => {
    const token = Storage.get( 'grupoimpar:token' );
    if ( !token ) {
      navigate( '/login?error=handoff_failed', { replace: true } );
      return;
    }
    dispatch( updateUserToken( token ) );
    bootstrap();
  }, [] );

  return accountModal;
}

export default SsoContinue;
